<template>
  <div>
    <div class="rank">
      <div class="rank-title" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`">
        <span>{{ activityData.title }}</span>
        <div>排 行 榜</div>
      </div>
      <div class="rank-nav" v-if="activityData.format && activityData.format.length > 1">
        <div class="rank-nav-item" v-if="activityData.format.includes('person') && !activityData.answerPerson.isShowRank" :style="`${ nav === 0 ? 'background: '+ (toRgba(activityData.themeColor, 1) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)') +';' : 'background: '+ (toTopBg(activityData.themeColor) || 'linear-gradient(-45deg, #C48989, #D1C7C3)') +';' }`" @click="handleNav('answerPerson', 0)">{{activityData.answerPerson.rankName || '个人赛'}}</div>
        <div class="rank-nav-item" v-if="activityData.format.includes('team') && !activityData.answerTeam.isShowRank" :style="`${ nav === 1 ? 'background: '+ (toRgba(activityData.themeColor, 1) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)') +';' : 'background: '+ (toTopBg(activityData.themeColor) || 'linear-gradient(-45deg, #C48989, #D1C7C3)') +';' }`" @click="handleNav('answerTeam', 1)">{{activityData.answerTeam.rankName || '团体赛'}}</div>
        <div class="rank-nav-item" v-if="activityData.format.includes('pk') && !activityData.answerPk.isShowRank" :style="`${ nav === 2 ? 'background: '+ (toRgba(activityData.themeColor, 1) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)') +';' : 'background: '+ (toTopBg(activityData.themeColor) || 'linear-gradient(-45deg, #C48989, #D1C7C3)') +';' }`" @click="handleNav('answerPk', 2)">{{activityData.answerPk.rankName || 'PK赛'}}</div>
      </div>
      <div class="rank-content" v-if="activityData[format]">
        <div class="rank-head" :style="`color: ${toRgbaText(activityData.themeColor)}`">
          <div v-if="activityData[format].rankList.includes('rank')" style="width: 15vw; flex-shrink: 0;">排名</div>
          <div v-if="activityData[format].rankList.includes('nickname') || activityData[format].rankList.includes('avatar')" style="width: 100%;">名称</div>
          <div v-if="activityData[format].rankList.includes('score')" style="width: 15vw; flex-shrink: 0; text-align: right;">分数</div>
        </div>
        <div class="rank-item" :style="`background: ${ activityData.themeColor ? toRgba(activityData.themeColor, 1) : 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" v-for="(item, index) in list" :key="index">
          <div v-if="activityData[format].rankList.includes('rank')" style="width: 15vw; flex-shrink: 0;">{{ index + 1 }}</div>
          <div v-if="activityData[format].rankList.includes('nickname') || activityData[format].rankList.includes('avatar')" class="nickname" style="width: 100%;">
            <img :src="item.avatar" alt="头像" v-if="activityData[format].rankList.includes('avatar') && item.avatar">
            <span v-if="activityData[format].rankList.includes('nickname')">{{ nav === 1 ? item.name : fmname(item.name || item.nickname) }}</span>
            <div v-if="nav !== 1 && item.institution" style="width: 100%;">{{ item.institution }}</div>
          </div>
          <div v-if="activityData[format].rankList.includes('score')" style="width: 15vw; flex-shrink: 0; text-align: right;">{{ item.score || item.value || 0 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import COVER from "@/utils/COVER";
import { mapState, mapActions, mapMutations } from "vuex";

let aid = '';
export default {
  name: 'Rank',
  props: ["activityData"],
  computed: {
    ...mapState(["userinfo"]),
  },
  data() {
    return {
      list: [],
      format: '',
      nav: null,
      teamList: [],
      otherList: [],
      isAiShow: false,
      newTableItem: null,
      reOrder: false,
    }
  },
  created() {
    aid = this.$route.query.id || "";
    const { format, answerPerson, answerTeam, answerPk } = this.activityData;

    // 判断是否开启赛制，获取赛制分数
    if (format.includes('person') && answerPerson && !answerPerson.isShowRank && answerPerson.rankList && answerPerson.rankList.length) {
      this.getList(1, answerPerson.rankCount, answerPerson.rankList.join(','));
      this.format = 'answerPerson';
      this.nav = 0;
    } else if (format.includes('team') && answerTeam && !answerTeam.isShowRank && answerTeam.rankList && answerTeam.rankList.length) {
      this.getList(2, answerTeam.rankCount, answerTeam.rankList.join(','));
      this.format = 'answerTeam';
      this.nav = 1;
    } else if (format.includes('pk') && answerPk && !answerPk.isShowRank && answerPk.rankList && answerPk.rankList.length) {
      this.getList(3, answerPk.rankCount, answerPk.rankList.join(','));
      this.format = 'answerPk';
      this.nav = 2;
    }
  },
  mounted() {
    COVER.yunTrack(this.aid, "load");
  },
  methods: {
    handleNav(key, index) {
      const config = this.activityData;
      this.getList(index + 1, config[key].rankCount, config[key].rankList.join(','));
      this.format = key;
      this.nav = index;
    },
    getSelfRank (aid, isAI) {
      COVER.$post('/answer/rank/self', {
        aid: aid,
        userinfo: this.userinfo
      }).then(res => {
        if (res.errno === 0 && res.data) {
          let data = res.data
          let rank = typeof data.rank === 'string' ? data.rank : data.rank + 1
          data.rank = rank
          if (isAI) {
            this.otherList.unshift(Object.assign({
              nickname: '我',
              isself: true,
            }, res.data))
          } else {
            this.list.unshift(Object.assign({
              nickname: '我',
              isself: true,
            }, res.data))
          }
        }
      });
    },
    getList(match, size, field) {
      // 如果是团体赛，则不获取个人信息
      if (match === 2) {
        this.getTeamRank();
        return;
      };
      COVER.$get('/answer/rank', {
        match,
        aid,
        size,
        field,
      }).then(res => {
        if (res.errno === 0) {
          this.list = res.data;
        }
      });
    },
    getTeamRank() {
      COVER.$get('/answer/team/rank', {
        aid,
      }).then(res => {
        if (res.errno === 0) {
          this.list = res.data || {};
        }
      });
    },
    fmname(val) {
      try {
        val = decodeURIComponent(escape(window.atob(val)))
      }
      catch(e) {
        
      }
      return val.substr(0, 1) + '*' + (val.length >= 3 ? val.substr(val.length - 1, val.length) : '');
    },
    toRgba(c, a = 0.7) {
      if (!c) {
        return;
      }
      return `linear-gradient(45deg, ${ COVER.hexToRgba(c, a) }, ${ COVER.hexToRgba(c) })`;
    },
    toTopBg(c) {
      return COVER.hexToRgba(c, 0.8);
    },
    toRgbaText(c) {
      return COVER.hexToRgba(c, 0.6);
    },
  }
}
</script>

<style lang="less" scoped>
.rank {
  overflow: scroll;
  height: 100%;
  width: 100%;
  position: fixed;
  padding-bottom: 8vw;
  box-sizing: border-box;
  .rank-title {
    font-size: 8vw;
    font-weight: bold;
    color: #fff;
    display: table;
    margin: 5vw auto;
    padding: 3vw 8vw;
    text-align: center;
    line-height: 1.5em;
    max-width: 90%;
    border-radius: 2vw;
    span {
      font-size: 6vw;
    }
  }
  .rank-content {
    width: 84vw;
    background: white;
    border-radius: 2vw;
    margin: 0 auto;
    padding: 4vw 5vw;
    box-sizing: border-box;
    .rank-head {
      font-size: 5.2vw;
      color: #C99F9E;
      font-weight: bold;
      display: flex;
      margin-bottom: 3vw;
      div {
        word-break: break-word;
      }
    }
    .rank-item {
      font-size: 4vw;
      color: white;
      padding: 0.6em 0.8em;
      box-sizing: border-box;
      display: flex;
      border-radius: 1vw;
      margin-top: 2vw;
      word-break: break-word;
      div {
        &:nth-child(1) {
          width: 23%;
        }
        &:nth-child(2) {
          width: 50%;
        }
        &:nth-child(3) {
          width: 25%;
          text-align: right;
        }
      }
      .nickname {
        display: flex;
        align-items: center;
        img {
          width: 6vw;
          height: 6vw;
          border-radius: 6vw;
          border: 1px solid rgba(0, 0, 0, 0.1);
          margin-right: 2vw;
        }
        span {
          flex-shrink: 0;
        }
        div {
          font-size: 2.4vw;
          margin-left: 3vw;
        }
      }
    }
    &.rank-content-add {
        .rank-head {
            div {
                width: 20%;
                &:nth-child(2) {
                    width: 20%;
                }
                &:nth-child(3) {
                    width: 35%;
                    text-align: left;
                }
                &:nth-child(4) {
                    width: 25%;
                    text-align: right;
                }
            }
        }
        .rank-item {
            div {
                width: 18%;
                &:nth-child(2) {
                    width: 20%;
                }
                &:nth-child(3) {
                    width: 37%;
                    text-align: left;
                }
                &:nth-child(4) {
                    width: 25%;
                    text-align: right;
                }
            }
        }
    }
  }
  .rank-nav {
    display: flex;
    font-size: 4.4vw;
    color: white;
    font-weight: bold;
    width: 84vw;
    margin: 0 auto 3vw auto;
    justify-content: space-between;
    .rank-nav-item {
      width: 100%;
      text-align: center;
      line-height: 2.5em;
      border-radius: 2vw;
      &:first-child {
        margin-right: 2vw;
      }
      &:last-child {
        margin-left: 2vw;
      }
    }
  }
}
</style>